import { List, Tooltip } from 'antd'
import _ from 'lodash'
import useProposal from '../hooks/useProposal'
import { CHECKLIST_EMPTY_LABEL, SCHEMA, SCHEMA_LABELS } from '../constants'
import { getProposalFieldDisplayValue } from '../helpers'
import styles from './ProposalChecklistAlert.css'

const SCHEMA_PATHS = [
  SCHEMA.TITLE,
  SCHEMA.BRAND,
  SCHEMA.ATTRIBUTES_TABLE,
  SCHEMA.PRODUCT_COPY,
  SCHEMA.SHORT_DESCRIPTION,
  SCHEMA.PRODUCT_IMAGES,
  SCHEMA.PRODUCT_SPECS
]

const hasValue = (value) => {
  if (value === null || value === undefined) {
    return false
  }

  if (Array.isArray(value)) {
    return value.length > 0
  }

  if (typeof value === 'string') {
    return value.trim() !== ''
  }

  if (typeof value === 'object') {
    return !_.isEmpty(value)
  }

  return true
}

const isGrayValue = (displayValue) => {
  if (displayValue === null || displayValue === undefined) {
    return true
  }

  const str = String(displayValue).trim()
  if (str === '' || str === CHECKLIST_EMPTY_LABEL) {
    return true
  }
  const num = Number(displayValue)
  return !Number.isNaN(num) && num === 0
}

const ProposalChecklistAlert = () => {
  const [proposal] = useProposal()

  const items = SCHEMA_PATHS.map((path) => {
    const value = _.get(proposal, path)
    const displayValue = _.isEmpty(proposal)
      ? '載入中...'
      : getProposalFieldDisplayValue(path, value)
    return {
      key: path,
      label: SCHEMA_LABELS[path],
      value,
      checked: hasValue(value),
      displayValue,
      isGray: isGrayValue(displayValue)
    }
  })

  return (
    <div className={styles.alert}>
      <List
        size='small'
        dataSource={items}
        className={styles.list}
        renderItem={({ key, label, displayValue, isGray }) => (
          <List.Item
            key={key}
            className={styles.listItem}
          >
            <span className={styles.label}>
              {`${label}：`}
            </span>
            <Tooltip
              title={displayValue}
              placement="topLeft"
            >
              <span
                className={isGray ? styles.valueEmpty : styles.value}
              >
                {displayValue}
              </span>
            </Tooltip>
          </List.Item>
        )}
      />
    </div>
  )
}

export default ProposalChecklistAlert
